import React from 'react'
import styled from 'styled-components'

const Label = styled.div`
  input {
    margin-left: 12px;
  }
`

const Toggle = ({ label, value, onChange, ...props }) => {
  return (
    <Label className='switch'>
      <label>{label}</label>
      <input type='checkbox' checked={value} onChange={onChange} {...props} />
      <span className='slider round'></span>
    </Label>
  )
}

export default Toggle
